export default "__VITE_ASSET__CCxS20C3__"